import React, { useEffect, useState } from "react";
import styles from "./ManageSpecialist.module.css";
import SpecialistProfile from "./SpecialistProfile";
import SpecialistInput from "./SpecialistInput";
import axios from "axios";

const ManageSpecialist = () => {
  return (
    <div className={styles.parent_container}>
      <SpecialistInput />
      <SpecialistProfile />
      {/* <SpecialistProfile /> */}
      {/* <SpecialistProfile /> */}
    </div>
  );
};

export default ManageSpecialist;
